import { motion } from "framer-motion";
function SkillCard({ skillTitle, skills, animVarient }) {
  return (
    <motion.div
      initial={{ scale: 0 }}
      whileInView={{ scale: 1, transition: { duration: 0.4 } }}
      viewport={{ once: true }}
      className="skill-card max-h-52 w-52 mt-12 "
    >
      <h3 className="font-extrabold">{skillTitle}</h3>
      <div className="relative flex flex-col flex-wrap h-5/6 mt-6 ">
        {/* animated left line */}
        <motion.div
          initial={{ height: 0 }}
          whileInView={{ height: "100%", transition: { type: "easeOut", duration: 0.7 } }}
          viewport={{ once: true }}
          className="absolute h-full left-0 top-0 w-[2px] bg-primary"
        ></motion.div>
        {skills &&
          skills.map((skill, index) => (
            <span key={index} className="el-skill-txt mx-3 mb-4 text-textGrey">
              {skill}
            </span>
          ))}
      </div>
    </motion.div>
  );
}

export default SkillCard;
